import * as types from '../actiontypes';
import env from '../../util/env';
import {serviceURL, routes, promiseAreas} from '../../util/uiconstants';

export function getEngagementMetrics(projectId, metricId, userType, selectedEngagements) {
	let baseUrl = env.getBaseURL(serviceURL);

	const metricRoutes = [
		routes.project.milestoneMetrics,
		routes.project.projectManagementMetrics,
		routes.project.groupAuditMetrics,
		routes.project.insightMetrics,
		routes.project.reportMetrics,
		routes.project.clientPortalMetrics
	];

	let url = `${baseUrl}${routes.project.root}/${projectId}/${metricRoutes[metricId - 1]}`;

	return {
		type: types.GET_ENGAGEMENT_METRICS,
		metricId,
		userType,
		selectedEngagements,
		meta: {
			api: {
				url: url,
				method: 'GET',
				trackWithArea: promiseAreas.ENGAGEMENT_METRICS_AREA
			}
		}
	};
}

export function cleanEngagementMetrics() {
	return {
		type: types.CLEAN_ENGAGEMENT_METRICS
	};
}
